import { EventTypeId } from '@swf/sports/types/eventType';
import type { IconName } from '@swf/sports/types/icon';

const EventTypeIcons: Partial<Record<EventTypeId, IconName>> = {
  [EventTypeId.AMERICAN_FOOTBALL]: 'american-football',
  [EventTypeId.ATHLETICS]: 'athletics',
  [EventTypeId.AUSTRALIAN_RULES]: 'australian-rules',
  [EventTypeId.BADMINTON]: 'badminton',
  [EventTypeId.BASKETBALL]: 'basketball',
  [EventTypeId.BASEBALL]: 'baseball',
  [EventTypeId.BEACH_VOLLEYBALL]: 'line-beach-volleyball',
  [EventTypeId.BOWLS]: 'bowls',
  [EventTypeId.BOXING]: 'boxing',
  [EventTypeId.CRICKET]: 'cricket',
  [EventTypeId.CYCLING]: 'cycling',
  [EventTypeId.CURLING]: 'curling',
  [EventTypeId.DARTS]: 'darts',
  [EventTypeId.DIVING]: 'diving',
  [EventTypeId.E_SPORTS]: 'esports',
  [EventTypeId.GREYHOUND_RACING]: 'greyhounds',
  [EventTypeId.HANDBALL]: 'handball',
  [EventTypeId.HOCKEY]: 'hockey',
  [EventTypeId.HORSE_RACING]: 'horse',
  [EventTypeId.ICE_HOCKEY]: 'ice-hockey',
  [EventTypeId.GOLF]: 'golf',
  [EventTypeId.GYMNASTICS]: 'gymnastics',
  [EventTypeId.MOTOR_SPORT]: 'motor-racing',
  [EventTypeId.NETBALL]: 'netball',
  [EventTypeId.POKER]: 'poker-fill',
  [EventTypeId.RUGBY_LEAGUE]: 'rugby-league',
  [EventTypeId.RUGBY_UNION]: 'rugby-union',
  [EventTypeId.ROWING]: 'rowing',
  [EventTypeId.SHOOTING]: 'shooting',
  [EventTypeId.SOCCER]: 'football',
  [EventTypeId.SPECIAL_BETS]: 'specials',
  [EventTypeId.SNOOKER]: 'snooker',
  [EventTypeId.SWIMMING]: 'swimming',
  [EventTypeId.TABLE_TENNIS]: 'table-tennis',
  [EventTypeId.TENNIS]: 'tennis',
  [EventTypeId.TRIATHLON]: 'triathlon',
  [EventTypeId.SURFING]: 'surfing',
  [EventTypeId.VOLLEYBALL]: 'volleyball',
  [EventTypeId.WATER_POLO]: 'water-polo',
  [EventTypeId.MIXED_MARTIAL_ARTS]: 'mixed-martial-arts',
  [EventTypeId.WEIGHTLIFTING]: 'weightlifting',
  [EventTypeId.WINTER_SPORTS]: 'winter-sports',
  [EventTypeId.WINTER_OLYMPICS]: 'winter-olympics',
  [EventTypeId.WRESTLING]: 'wrestling'
};

/**
 * Gets the icon name for the event types, if there's no icon for specified event type,
 * it returns the 'trophy' icon.
 * @example EventTypeId.WINTER_OLYMPICS
 * returns 'winter-olympics'
 * @example EventTypeId.LOTTERIES
 * returns 'trophy'
 */
export const getEventTypeIcon = (eventType?: EventTypeId): IconName =>
  eventType ? EventTypeIcons[eventType] ?? 'trophy' : 'trophy';
